import { runSlider, videoNav } from './scripts';

document.addEventListener('DOMContentLoaded', function () {
	runSlider();
	videoNav();
})
